import React from 'react';
import { useTheme } from 'styled-components';

import { FaMedal } from 'react-icons/fa';
import { FaTrophy } from 'react-icons/fa';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  TooltipProps,
} from 'recharts';

import { Container, Description } from './styles';

import { GraficoProps } from './interface';

import RelatorioVendaTopProdutosProdutoType from '~/@types/relatoriovendatoprodutosproduto';

import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';

interface CustomTooltipProps extends TooltipProps<ValueType, NameType> {
  // Add any additional custom props you might need
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
}) => {
  const { colors } = useTheme();

  if (active && payload && Array.isArray(payload) && payload.length) {
    const [cPayload] = payload;

    if (cPayload) {
      const { payload: _payload } = cPayload;
      if (_payload) {
        const item: RelatorioVendaTopProdutosProdutoType = {
          ..._payload,
        };

        return (
          <Description>
            <header>
              <h1>
                <span>{item.posicao}</span>
              </h1>
              {item._posicao <= 3 ? (
                <i>
                  {item._posicao === 1 ? (
                    <FaTrophy size={22} color={colors.IC1} />
                  ) : (
                    <FaMedal size={22} color={colors.IC1} />
                  )}
                </i>
              ) : null}
            </header>
            <main>
              <h2>SKU: {item.sku}</h2>
              <h3>{item.nome}</h3>
              <ins />
              <h4>
                QUANTIDADE: <b>{item.qtdtotal}</b>
              </h4>
              <h5>
                TOTAL:
                <b>
                  {item.total.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </b>
              </h5>
            </main>
          </Description>
        );
      }
    }
  }

  return null;
};

const Grafico: React.FC<GraficoProps> = ({ topprodutos }) => {
  return (
    <Container>
      <ResponsiveContainer>
        <BarChart
          data={topprodutos}
          margin={{
            top: 0,
            right: 10,
            left: 30,
            bottom: 25,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />

          <YAxis
            tickFormatter={value =>
              `${value.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}`
            }
            tick={{ fill: '#999', fontSize: 8 }}
          />

          <XAxis
            dataKey="posicao"
            stroke={'#999'}
            fontSize={10}
            angle={0}
            textAnchor="end"
            tickMargin={10}
            dx={25}
          />
          <Tooltip
            content={<CustomTooltip />}
            cursor={{ fill: 'rgba(255,255,255, 0.1)' }}
          />

          <YAxis />
          <Tooltip />

          <Bar
            type="monotone"
            dataKey={'total'}
            fill="#555"
            radius={[6, 6, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </Container>
  );
};

export default Grafico;
